import React from "react";
import CompanyDetails from "./CompanyDetails";
import PatientDetails from "./PatientDetails";
import Plan from "./Plan";
import PrintWrapper from "./PrintWrapper.style";

const PrintPlan = (props) => {
  const { order } = props;
  const selectedOrder = order || {};
  return (
    <PrintWrapper>
      <div className="pdf" dir="rtl">
        <div>
          <CompanyDetails />
          <div className="verticalSeperator" />
          <PatientDetails order={selectedOrder} />
          <div className="verticalSeperator" />
          <Plan order={selectedOrder} />
          <div className="verticalSeperator" />
        </div>
      </div>
    </PrintWrapper>
  );
};

export default PrintPlan;
